import type { Action } from './actions'

export type PluginType = 'CATALOG'

export type BaseActionDefinition<TName = string> = {
  name: TName
  label: string
  experiment?: string
  supportedInsideRepeater?: boolean
}

export type CollectionActionDefinition = BaseActionDefinition<Action> & {
  type: 'collection'
  collectionId: string
}

export type PluginTypeActionDefinition = BaseActionDefinition<Action> & {
  type: 'pluginType'
  pluginType: PluginType
}

export type GlobalActionDefinition<TName = string> =
  BaseActionDefinition<TName> & {
    type?: never
  }

export type ActionDefinition<TName = string> =
  | CollectionActionDefinition
  | PluginTypeActionDefinition
  | GlobalActionDefinition<TName>

// TPA actions only (collection or plugin specific)
export type TpaActionDefinition =
  | CollectionActionDefinition
  | PluginTypeActionDefinition

export const actions: TpaActionDefinition[] = [
  {
    type: 'collection',
    collectionId: 'StoreCatalog/Products',
    name: 'tpa/quicklyViewProduct',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_AddProductToCart',
    supportedInsideRepeater: true,
  },
  {
    type: 'collection',
    collectionId: 'StoreCatalog/Products',
    name: 'tpa/quicklyViewProduct',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_QuicklyViewProduct',
    supportedInsideRepeater: true,
  },
  {
    type: 'collection',
    collectionId: 'Stores/Products',
    name: 'tpa/addProductToCart',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_AddProductToCart',
    supportedInsideRepeater: true,
  },
  {
    type: 'collection',
    collectionId: 'Stores/Products',
    name: 'tpa/quicklyViewProduct',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_QuicklyViewProduct',
    supportedInsideRepeater: true,
  },
  {
    type: 'collection',
    collectionId: 'Stores/Variants',
    name: 'tpa/addVariantToCart',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_AddVariantToCart',
    supportedInsideRepeater: true,
  },
  {
    type: 'collection',
    collectionId: 'PaidPlans/Plans',
    name: 'tpa/purchasePricingPlan',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_PurchasePricingPlan',
    supportedInsideRepeater: true,
  },
  {
    type: 'collection',
    collectionId: 'PaidPlans/Plans',
    name: 'tpa/pricingPlansNavigateToCheckout',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_PricingPlansNavigateToCheckout',
    supportedInsideRepeater: true,
  },
  {
    type: 'pluginType',
    pluginType: 'CATALOG',
    name: 'tpa/catalogCollectionAddToCart',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_CatalogCollectionAddToCart',
    supportedInsideRepeater: true,
  },
  {
    type: 'pluginType',
    pluginType: 'CATALOG',
    name: 'tpa/catalogCollectionBuyNow',
    label:
      'Connect_Panel_Connect_Link_Dropdown_Options_Actions_Tpa_CatalogCollectionBuyNow',
    supportedInsideRepeater: true,
  },
]
